<template>
  <div class="modernBox" :class="{lowerpage: isLowerPage}">

    <div class="modernBox__contents" v-if="isSp" >
      <div class="listGroup u-mg-0"
           data-color="secondary"
           data-size="lg">
        <div class="listGroup__body lateral__slide___wrapper">
          <ul class="lateral__slide">
            <template v-for="(item, index) in listitems">
              <li class="lateral__slide__list text" data-arrow="false" :key="index" v-if="checkExclude(item.items_id)">
                <a class="lateral__slide__link"
                   :href="`${item.url}${page === '' ? '' : `?${page}=${index + 1}`}`"
                   :data-items-id="item.items_id"
                   :target="item.blank != null && item.blank ? '_blank' : ''"
                >
                  <div class="lateral__slide__image" data-size="xm" data-clip-path-support="true">
                    <img data-clip-path-support="true" data-size="xm" size="xm" :src="item.pack_image">
                  </div>
                </a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>

    <div class="modernBox__contents" v-else>
      <div class="listGroup u-mg-0"
           data-color="secondary"
           data-size="lg">
        <div class="listGroup__body lateral__slide___wrapper">
          <swiper :options="swiperOptions" class="lateral__slide__swiper">
            <swiper-slide v-for="(item, index) in listitems" :key="index" class="lateral__slide__swiper--slide">
              <div class="lateral__slide">
                <div class="lateral__slide__list text">
                  <a class="lateral__slide__link"
                     :href="`${item.url}${page === '' ? '' : `?${page}=${index + 1}`}`"
                     :data-items-id="item.items_id"
                     :target="item.blank != null && item.blank ? '_blank' : ''"
                  >
                    <div class="lateral__slide__image" data-size="xm" data-clip-path-support="true">
                      <img data-clip-path-support="true" data-size="xm" size="xm" :src="item.pack_image">
                    </div>
                  </a>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'


export default {
  name: 'videoletteritems-list',
  components: { swiper, swiperSlide },
  data() {
    return {
      listitems: [
        {
          items_id: 9,
          item_name: '2020年の運勢',
          pack_image: '/static/img/top/slide/topslide_2020luck.jpg',
          url: '/2020_luck',
          price: '500',
          starGetId: '2020_luck',
          blank: false
        },
        {
          items_id: 9,
          item_name: '占いフェス 2020 NEWYEAR',
          pack_image: '/static/img/top/slide/topslide_ufes2020newyear.png',
          url: 'https://uranaifes.com/2020newyear/',
          price: '500',
          starGetId: 'uranaifes2020newyear',
          blank: true
        },
        {
          items_id: 12,
          item_name: 'Licorice',
          pack_image: '/static/img/top/slide/topslide_licorice.png',
          url: '/lp/movie/licorice',
          price: '990',
          starGetId: 'licorice',
          blank: false
        }
      ],
      swiperOptions: {
        spaceBetween: this.device === 'sp' ? 8 : 12,
        roundLengths: true,
        slidesPerView:'auto',
        navigation: { //前へ・次へのナビ設定
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },
  props: {
    isRecommend: { type: Boolean, defualt: false },
    excludeId: { type: Number, default: null },
    page: { type: String, default: 'top_fst' },
    isLowerPage:{ type: Boolean, default(){ return false } }
  },
  computed: {
    isSp () {
      let res = false
      const regexp = /Android|iPhone|iPad|iPod/i;
      if(window.navigator.userAgent.search(regexp) !== -1){
        res = true
      }
      return res
    },
  },
  methods: {
    checkExclude (id) {
      let check = false
      let exid = this.excludeId

      if(exid === 13) { //リコリス無料版(13)のとき=>リコリス扱いに
        exid = 12
      }
      if(id !== exid){
        check = true
      }

      return check
    }
  }
};
</script>
<style lang="scss" scoped>


//横スライド
.lateral__slide___wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  background: #f3f3f3;
  height: 272px;
  width: auto;
  padding: 16px;
}
.lateral__slide {
  background: #f3f3f3;
  display: inline-flex;
  -webkit-box-align: start;
  align-items: flex-start;
  width: auto;
  height: 100%;
  padding: 0 !important;
  margin: 0;
  list-style: none;
  -webkit-overflow-scrolling: touch;
}

// vue-awesome-swiper
.lateral__slide__swiper {
  height: 100%;
  width: auto;
  &--slide {
    width: auto;
    margin: 0
  }
  .swiper-button-prev,
  .swiper-button-next {
    background: rgba(0,0,0,.6);
    width: 48px;
    height: 48px;
    border-radius: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    &.swiper-button-disabled {
      opacity: 0;
    }
    &::before,
    &::after {
      content: '';
      width: 12px;
      height: 2.5px;
      border-radius: 2.5px;
      background: white;
      display: block;
    }
  }

  .swiper-button-prev {
    &::before {
      transform: translate(4px, 3px) rotate(45deg);
    }
    &::after {
      transform: translate(-8.5px, -4px) rotate(-45deg);
    }
  }
  .swiper-button-next {
    &::before {
      transform: translate(6px, 3px) rotate(-45deg);
    }
    &::after {
      transform: translate(-5.5px, -4px) rotate(45deg)
    }
  }
}

.lateral__slide__list {
  position: relative;
  border: 1px solid #ededed;
  box-sizing: border-box;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  height: 100%;
  width: 100%;
  &:nth-of-type(n + 2) {
    margin-left: 16px;
  }
}
.lateral__slide__link {
  text-decoration: none;
}
.lateral__slide__image {
  height: 100%;
  width: auto;
  position: relative;
  /*&::after {
    content: '';
    width: 24px;
    height: 24px;
    display: block;
    position: absolute;
    top: 8px;
    right: 8px;
    background: url('/static/img/ic-movie-contents.svg') no-repeat center center;
    background-size: 100%;
  }*/
  img {
    height: 100%;
    width: auto;
    border-radius: 5px;
    display: block;
  }
}

.lateral__slide__text {
  margin: 8px 8px 0;
}
.lateral__slide__title__wrapper {
  overflow: hidden;
}
.lateral__slide__title {
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.08em;
  margin: 0;
  width: 146px;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.lateral__slide__stars {
  display: block;
  width: 100%;
  padding: 2px 7px 0;
}
.lateral__slide__price {
  position: absolute;
  right: 0;
  bottom: 6px;
  p {
    font-weight: bold;
    color: #ed1e79;
    font-size: 12px;
    line-height: 12px;
  }
  span {
    color: #676767;
    font-weight: normal;
    font-size: 10px;
    margin-right: 8px;
  }
}
.lowerpage {
  .lateral__slide__price {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/VideoletteritemsList.vue